var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedBirth)?_c('div',[_c('show',{attrs:{"birth":_vm.selectedBirth}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }